import React, { ChangeEvent, useState } from "react";
import OwTitle from "../../../../shared/OwTitle/OwTitle";
import OwButton from "../../../../shared/OwButton/OwButton";
import OwCheckbox from "../../../../shared/OwCheckbox/OwCheckbox";
import QBDQueueActionEnum from "../../../../../models/QBDQueueActionEnum";
import moment from "moment";
import OwDateInput from "../../../../shared/OwDateInput/OwDateInput";
import OwLabel from "../../../../shared/OwLabel/OwLabel";
import IQBDQueueOptions from "../../../../../models/IQBDQueueOptions";
import { OwFnInput } from "../../../../shared/OwFnInput/OwFnInput";

type Props = {
    closeModalFn: () => void;
    setDataPullFn: (queueOptions: { [key: string]: boolean }, queueItemsOptions?: IQBDQueueOptions) => void;
};

export const QuickbooksDesktopSetupDataPullModal = (props: Props) => {
    const [bulkCheckStatus, setBulkCheckStatus] = useState(false);

    const [dataPullItems, setDataPullItems] = useState({
        [QBDQueueActionEnum.READ_PRODUCTS]: true,
        [QBDQueueActionEnum.READ_CUSTOMERS]: true,
        [QBDQueueActionEnum.READ_VENDORS]: true,
        [QBDQueueActionEnum.READ_INCOME_ACCOUNT_OPTIONS]: true,
        [QBDQueueActionEnum.READ_TERMS]: true,
        [QBDQueueActionEnum.READ_SALES_TAX_OPTIONS]: true,
        [QBDQueueActionEnum.READ_ASSET_ACCOUNT_OPTIONS]: true,
        [QBDQueueActionEnum.READ_COGS_ACCOUNT_OPTIONS]: true,
        [QBDQueueActionEnum.READ_TEMPLATES]: true,
        [QBDQueueActionEnum.READ_SALES_REPS]: true,
        [QBDQueueActionEnum.READ_ITEM_SUBTOTALS]: true,
        [QBDQueueActionEnum.READ_PRICE_LEVELS]: true,
        [QBDQueueActionEnum.READ_INVENTORY_SITE_LIST]: true,
        [QBDQueueActionEnum.READ_SALES_TAX_ITEMS]: true,
        [QBDQueueActionEnum.READ_UNIT_OF_MEASURE]: true,
        [QBDQueueActionEnum.READ_ITEM_SITES]: true,
        [QBDQueueActionEnum.READ_CLASS]: true,
        [QBDQueueActionEnum.READ_SHIP_METHOD]: true,
        [QBDQueueActionEnum.READ_DATA_EXT_DEFS]: true,
        // [QBDQueueActionEnum.READ_INVOICES]: false,
        [QBDQueueActionEnum.READ_SALES_ORDERS]: false,
        [QBDQueueActionEnum.READ_PURCHASE_ORDERS]: false,
    });

    const [invoicesFromTxnDate, setInvoicesFromTxnDate] = useState(moment().format("YYYY-MM-DD"));

    const [salesOrdersFromTxnDate, setSalesOrdersFromTxnDate] = useState<string | undefined>(moment().format("YYYY-MM-DD"));
    const [salesOrdersToTxnDate, setSalesOrdersToTxnDate] = useState<string | undefined>();
    const [refNumber, setRefNumber] = useState<string[]>([]);
    const [refNumberEntry, setRefNumberEntry] = useState<string>("");

    const [purchaseOrdersFromTxnDate, setPurchaseOrdersFromTxnDate] = useState<string | undefined>(moment().format("YYYY-MM-DD"));
    const [purchaseOrdersToTxnDate, setPurchaseOrdersToTxnDate] = useState<string | undefined>();
    const [poRefNumber, setPoRefNumber] = useState<string[]>([]);
    const [poRefNumberEntry, setPoRefNumberEntry] = useState<string>("");

    const [autoProcessCustomers, setAutoProcessCustomers] = useState<boolean>(false);
    const [autoProcessProducts, setAutoProcessProducts] = useState<boolean>(false);

    const handleChange = (e: ChangeEvent<any>) => {
        const name = e.target.name;
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;

        if (name === "refNumberEntry") {
            setRefNumberEntry(value);
        } else if (name === "autoProcessCustomers") {
            setAutoProcessCustomers(value);
        } else if (name === "autoProcessProducts") {
            setAutoProcessProducts(value);
        } else if (name === "poRefNumberEntry") {
            setPoRefNumberEntry(value);
        } else {
            setDataPullItems({
                ...dataPullItems,
                [name]: value,
            });
        }
    };

    const handleDateChange = (
        momentObj: moment.Moment,
        item:
            | "invoices"
            | "sales_orders_to_txn_date"
            | "sales_orders_from_txn_date"
            | "purchase_orders_from_txn_date"
            | "purchase_orders_to_txn_date"
    ) => {
        switch (item) {
            case "invoices":
                setInvoicesFromTxnDate(momentObj.format("YYYY-MM-DD"));
                break;
            case "sales_orders_from_txn_date":
                setSalesOrdersFromTxnDate(momentObj.format("YYYY-MM-DD"));
                break;
            case "sales_orders_to_txn_date":
                setSalesOrdersToTxnDate(momentObj.format("YYYY-MM-DD"));
                break;
            case "purchase_orders_from_txn_date":
                setPurchaseOrdersFromTxnDate(momentObj.format("YYYY-MM-DD"));
                break;
            case "purchase_orders_to_txn_date":
                setPurchaseOrdersToTxnDate(momentObj.format("YYYY-MM-DD"));
                break;
        }
    };

    const toggleCheckAll = () => {
        const updatedPullItems = {
            ...dataPullItems,
        };

        Object.keys(dataPullItems).forEach((pullItemKey) => {
            // @ts-expect-error
            updatedPullItems[pullItemKey] = bulkCheckStatus;
        });

        setDataPullItems(updatedPullItems);
        setBulkCheckStatus(!bulkCheckStatus);
    };

    const submitDataPull = () => {
        const queueItemOptions: IQBDQueueOptions = {};

        if (salesOrdersFromTxnDate && dataPullItems[QBDQueueActionEnum.READ_SALES_ORDERS]) {
            if (salesOrdersFromTxnDate || salesOrdersToTxnDate || refNumber.length) {
                queueItemOptions.SalesOrders = {};

                if (salesOrdersFromTxnDate.length && moment(salesOrdersFromTxnDate).isValid()) {
                    queueItemOptions.SalesOrders.fromTxnDate = salesOrdersFromTxnDate;
                }

                if (salesOrdersToTxnDate?.length && moment(salesOrdersToTxnDate).isValid()) {
                    queueItemOptions.SalesOrders.toTxnDate = salesOrdersToTxnDate;
                }

                if (refNumber.length) {
                    queueItemOptions.SalesOrders.refNumber = refNumber;
                }
            }
        }

        if (purchaseOrdersFromTxnDate && dataPullItems[QBDQueueActionEnum.READ_PURCHASE_ORDERS]) {
            if (purchaseOrdersFromTxnDate || purchaseOrdersToTxnDate || poRefNumber.length) {
                queueItemOptions.PurchaseOrders = {};

                if (purchaseOrdersFromTxnDate.length && moment(purchaseOrdersFromTxnDate).isValid()) {
                    queueItemOptions.PurchaseOrders.fromTxnDate = purchaseOrdersFromTxnDate;
                }

                if (purchaseOrdersToTxnDate?.length && moment(purchaseOrdersToTxnDate).isValid()) {
                    queueItemOptions.PurchaseOrders.toTxnDate = purchaseOrdersToTxnDate;
                }
            }
        }

        // if (invoicesFromTxnDate && dataPullItems[QBDQueueActionEnum.READ_INVOICES]) {
        //     queueItemOptions.Invoices = {
        //         fromTxnDate: invoicesFromTxnDate,
        //     }
        // }

        if (autoProcessCustomers) {
            queueItemOptions.Customers = {
                autoProcess: true,
            };
        }

        if (autoProcessProducts) {
            queueItemOptions.Products = {
                autoProcess: true,
            };
        }

        props.setDataPullFn(dataPullItems, queueItemOptions);
        props.closeModalFn();
    };

    return (
        <div className={"QuickbooksDesktopSetupDataPullModal p-2"}>
            <div className={"d-flex justify-content-between"}>
                <OwTitle title={"setup_data_pull"} leftIconName={"fad fa-clock"} />
                <div>
                    <OwButton centerIconClass={"fas fa-times"} className={"btn-danger"} fn={props.closeModalFn} />
                </div>
            </div>
            <div className="mt-2">
                <div>
                    <OwButton title={bulkCheckStatus ? "check_all" : "uncheck_all"} fn={toggleCheckAll} />
                </div>
                <div className="mt-2">
                    {Object.keys(dataPullItems).map((dataPullItemKey) => {
                        // @ts-expect-error
                        const isChecked = dataPullItems[dataPullItemKey];

                        let label = dataPullItemKey.toLowerCase();

                        if (dataPullItemKey === QBDQueueActionEnum.READ_DATA_EXT_DEFS) {
                            label = "custom_fields";
                        }

                        return (
                            <div key={dataPullItemKey} className={"d-flex align-items-start"}>
                                <OwCheckbox
                                    fn={handleChange}
                                    name={dataPullItemKey}
                                    label={label}
                                    truthyVal={true}
                                    falsyVal={false}
                                    checked={isChecked}
                                />
                                {dataPullItemKey === QBDQueueActionEnum.READ_CUSTOMERS && isChecked ? (
                                    <div className={"ms-1 d-flex align-items-start"}>
                                        <OwCheckbox
                                            label={"auto_process"}
                                            fn={handleChange}
                                            name={"autoProcessCustomers"}
                                            checked={autoProcessCustomers}
                                            truthyVal={true}
                                            falsyVal={false}
                                        />
                                    </div>
                                ) : null}
                                {dataPullItemKey === QBDQueueActionEnum.READ_PRODUCTS && isChecked ? (
                                    <div className={"ms-1 d-flex align-items-start"}>
                                        <OwCheckbox
                                            label={"auto_process"}
                                            fn={handleChange}
                                            name={"autoProcessProducts"}
                                            checked={autoProcessProducts}
                                            truthyVal={true}
                                            falsyVal={false}
                                        />
                                    </div>
                                ) : null}
                                {dataPullItemKey === QBDQueueActionEnum.READ_INVOICES && isChecked ? (
                                    <div className={"ms-1 d-flex align-items-start"}>
                                        <OwLabel title={"from"} postText={":"} className={"me-2"} />
                                        <OwDateInput
                                            fn={(momentObj) => {
                                                handleDateChange(momentObj, "invoices");
                                            }}
                                            selectedDate={invoicesFromTxnDate}
                                        />
                                    </div>
                                ) : null}
                                {dataPullItemKey === QBDQueueActionEnum.READ_SALES_ORDERS && isChecked ? (
                                    <div className={"ms-1 d-flex flex-column align-items-start"}>
                                        <div>
                                            <OwLabel title={"from"} postText={":"} className={"me-2"} />
                                            <OwDateInput
                                                fn={(momentObj) => {
                                                    handleDateChange(momentObj, "sales_orders_from_txn_date");
                                                }}
                                                selectedDate={salesOrdersFromTxnDate}
                                            />
                                        </div>
                                        <div className="mt-2">
                                            <OwLabel title={"to"} postText={":"} className={"me-2"} />
                                            <OwDateInput
                                                fn={(momentObj) => {
                                                    handleDateChange(momentObj, "sales_orders_to_txn_date");
                                                }}
                                                selectedDate={salesOrdersToTxnDate}
                                            />
                                        </div>
                                        <div className="mt-2">
                                            <OwLabel title={"ref_number"} postText={":"} className={"me-2"} />
                                            <div className={"input-group"}>
                                                <OwFnInput
                                                    fn={handleChange}
                                                    noOuterDiv={true}
                                                    name={"refNumberEntry"}
                                                    value={refNumberEntry}
                                                />
                                                <OwButton
                                                    leftIconClass={"fas fa-plus"}
                                                    title={"add"}
                                                    fn={() => {
                                                        setRefNumber([...refNumber, refNumberEntry]);
                                                        setRefNumberEntry("");
                                                    }}
                                                />
                                            </div>
                                            <div className="mt-2">
                                                {refNumber.map((refNumberItem, index) => {
                                                    return (
                                                        <div key={index}>
                                                            <i
                                                                className={"fad fa-trash-alt text-danger pointer"}
                                                                onClick={() => {
                                                                    setRefNumber(refNumber.filter((item) => item !== refNumberItem));
                                                                }}
                                                            />
                                                            <span className="ms-2 text-muted">{refNumberItem}</span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                ) : null}

                                {dataPullItemKey === QBDQueueActionEnum.READ_PURCHASE_ORDERS && isChecked ? (
                                    <div className={"ms-1 d-flex flex-column align-items-start"}>
                                        <div>
                                            <OwLabel title={"from"} postText={":"} className={"me-2"} />
                                            <OwDateInput
                                                fn={(momentObj) => {
                                                    handleDateChange(momentObj, "purchase_orders_from_txn_date");
                                                }}
                                                selectedDate={purchaseOrdersFromTxnDate}
                                            />
                                        </div>
                                        <div className="mt-2">
                                            <OwLabel title={"to"} postText={":"} className={"me-2"} />
                                            <OwDateInput
                                                fn={(momentObj) => {
                                                    handleDateChange(momentObj, "purchase_orders_to_txn_date");
                                                }}
                                                selectedDate={purchaseOrdersToTxnDate}
                                            />
                                        </div>
                                        <div className="mt-2">
                                            <OwLabel title={"ref_number"} postText={":"} className={"me-2"} />
                                            <div className={"input-group"}>
                                                <OwFnInput
                                                    fn={handleChange}
                                                    noOuterDiv={true}
                                                    name={"poRefNumberEntry"}
                                                    value={poRefNumberEntry}
                                                />
                                                <OwButton
                                                    leftIconClass={"fas fa-plus"}
                                                    title={"add"}
                                                    fn={() => {
                                                        setPoRefNumber([...poRefNumber, poRefNumberEntry]);
                                                        setPoRefNumberEntry("");
                                                    }}
                                                />
                                            </div>
                                            <div className="mt-2">
                                                {poRefNumber.map((poRefNumberItem, index) => {
                                                    return (
                                                        <div key={index}>
                                                            <i
                                                                className={"fad fa-trash-alt text-danger pointer"}
                                                                onClick={() => {
                                                                    setPoRefNumber(poRefNumber.filter((item) => item !== poRefNumberItem));
                                                                }}
                                                            />
                                                            <span className="ms-2 text-muted">{poRefNumberItem}</span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        );
                    })}
                </div>

                <div className="mt-2">
                    <OwButton title={"submit"} fn={submitDataPull} />
                </div>
            </div>
        </div>
    );
};
